import { displayToast, sendAppsignalError } from "../modules/utils";
import AjaxModal from "./ajax_modal";

export default class FacebookPoster {
  constructor(configContext, content = { text: "", media: "", mediaType: "" }) {
    this.content = content;
    this.appId = configContext.facebookAppId;
    this.authenticationConfigId = configContext.facebookAuthenticationConfigId;

    // TODO: For in the future, we should use I18n for these messages
    this.authorizedMessage = configContext.authorizedMessage;
    this.unAuthorizedMessage = configContext.unAuthorizedMessage;
    this.errorFacebookMessage = configContext.errorFacebookMessage;
    this.noFacebookPagesMessage = configContext.noFacebookPagesMessage;
    this.errorPostMessage = configContext.errorPostMessage;
    this.successfulPostMessage = configContext.successfulPostMessage;
    this.modalElementUrl = configContext.facebookModalUrl;

    this.initialize();
  }

  async initialize() {
    this.checkValidContent();

    if (this.invalid) return;

    if (typeof FB == "undefined") {
      await this.addFacebookSDK().then(() => {
        this.handleFacebookPost();
      });
    } else {
      this.handleFacebookPost();
    }
  }

  checkValidContent() {
    if (this.content.media == "" && this.content.text == "") {
      // When no content is provided, we don't want to continue
      console.log("no content to post");
      displayToast(this.errorPostMessage);
      sendAppsignalError("No content to post", "FacebookPoster", {});

      this.invalid = true;
      return;
    }
  }

  async addFacebookSDK() {
    return new Promise((resolve) => {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");

      window.fbAsyncInit = () => {
        FB.init({
          appId: this.appId,
          cookie: true,
          xfbml: true,
          version: "v20.0",
        });

        FB.AppEvents.logPageView();

        resolve();
      };
    });
  }
  handleFacebookPost() {
    // We check if the user is already logged in to Facebook, otherwise we log them in.
    FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        this.postAfterFacebookLogin();
      } else {
        FB.login(
          (response) => {
            if (response.status === "connected") {
              displayToast(this.authorizedMessage, "success");
              this.postAfterFacebookLogin();
            } else {
              displayToast(this.unAuthorizedMessage);
              sendAppsignalError("Unable to log into facebook", "FacebookPoster", response);
            }
          },
          {
            config_id: this.authenticationConfigId, // Facebook permissions: ["pages_manage_posts", "pages_show_list", "publish_video"]
          }
        );
      }
    });
  }

  postAfterFacebookLogin() {
    const pagesData = []; // We build a dropdown with the pages the user has access to

    FB.api("me/accounts", (response) => {
      if (!response || response.error) {
        displayToast(this.errorFacebookMessage);
        sendAppsignalError("Unable to fetch Facebook pages", "SocialMediaCreator", response);
        return;
      }

      response.data.forEach((page) => {
        pagesData.push({ id: page.id, name: page.name, accessToken: page.access_token });
      });

      if (pagesData.length === 0) {
        displayToast(this.noFacebookPagesMessage);
        // There is no point in continuing if the user has no admin right for pages
        return;
      }

      // Now we initialize the modal to display the Facebook post options
      const modalLink = document.body.appendChild(document.createElement("a"));
      modalLink.href = this.modalElementUrl;
      this.facebookModal = new AjaxModal(modalLink);
      modalLink.remove(); // Remove from the DOM after the modal is created
    });

    window.addEventListener(
      "modal:loaded",
      () => {
        if (this.facebookModal.modalElement === undefined) {
          return;
          // A modal was loaded but it's not the Facebook modal
        }

        const facebookBusinessSelect = this.facebookModal.modalElement.querySelector(".js-business-posts-select");
        const facebookBusinessPost = this.facebookModal.modalElement.querySelector(".js-business-post");

        // We populate the select options with the pages the user has access to.
        facebookBusinessSelect.innerHTML = pagesData.map((page) => {
          return `<option value="${page.id}">${page.name}</option>`;
        });

        // We set the first page as the default active page
        let activePageId = pagesData[0].id;
        let pageAccessToken = pagesData[0].accessToken;

        // These event listeners don't need to be removed since the modal is destroyed after it's closed
        facebookBusinessSelect.addEventListener("change", () => {
          activePageId = facebookBusinessSelect.value;
          pageAccessToken = pagesData.find((page) => page.id === activePageId).accessToken;
        });

        facebookBusinessPost.addEventListener("click", () => {
          this.postToFacebook(activePageId, pageAccessToken);
        });
      },
      { once: true }
    );
  }

  postToFacebook(activePageId, pageAccessToken) {
    this.facebookModal.modalElement.classList.add("posting");

    let url = "";
    let params = {};

    if (this.content.media === "" && this.content.text !== "") {
      // We have text content but no media

      url = `/${activePageId}/feed`;
      params = {
        message: this.content.text,
        published: true,
      };
      return;
    }

    // We know we have media content, so we need to check if it's a video or a photo, text is optional
    if (this.content.mediaType === "video") {
      url = `/${activePageId}/videos`;
      params = {
        description: this.content.text,
        file_url: this.content.media,
      };
    } else {
      url = `/${activePageId}/photos`;
      params = {
        message: this.content.text,
        url: this.content.media,
        published: true,
      };
    }

    params.access_token = pageAccessToken;

    FB.api(url, "POST", params, (response) => {
      this.facebookModal.modalElement.classList.remove("posting");

      if (!response || response.error) {
        displayToast(this.errorPostMessage);
        sendAppsignalError("Unable to post to Facebook", "SocialMediaCreator", response);
      } else {
        this.facebookModal.modal.hide();
        displayToast(this.successfulPostMessage, "success");
      }
    });
  }
}
